import BlocksContainer from '../../components/Blocks/Core/BlocksContainer';
import { BlockDataPerPage } from '../../contexts/PagesContext';
import BlockData from '../../models/BlockData';

function MainContainer(props: { page?: BlockDataPerPage, blocksData: BlockData[] }) {
  const { page, blocksData } = props;
  return (
    <BlocksContainer page={page} blocksData={blocksData} />
  );
}

export default MainContainer;
